export const isLoginReducer = (state = {isLogin: "false"}, action) => {
    switch(action.type){
        case 'UPDATE_IS_LOGIN': return {...state, isLogin: action.payload.isLogin
        }
        default: return state
    }
}
